import { ReSendUserVerifyMutationContext } from '@/bo-kit/components/VerifyAccountPage/components/VerifyAccountForm/hooks/useDoReSendUserVerify';
import { FC, PropsWithChildren } from 'react';
import { useReSendUserVerifyMutation } from '../gatewayApi';

export const UseReSendUserVerifyMutationContextProvider: FC<PropsWithChildren> = ({ children }) => {
    const [doResend, state] = useReSendUserVerifyMutation();
    return (
        <ReSendUserVerifyMutationContext.Provider value={[doResend, state]}>
            {children}
        </ReSendUserVerifyMutationContext.Provider>
    );
};
